import { render, staticRenderFns } from "./seasonprices.vue?vue&type=template&id=18f35a6c&"
import script from "./seasonprices.vue?vue&type=script&lang=js&"
export * from "./seasonprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f35a6c')) {
      api.createRecord('18f35a6c', component.options)
    } else {
      api.reload('18f35a6c', component.options)
    }
    module.hot.accept("./seasonprices.vue?vue&type=template&id=18f35a6c&", function () {
      api.rerender('18f35a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29NZOw29qBVuz/JS/comp/seasonprices.vue"
export default component.exports